import Automation from "../images/automation"
import Plus from "../images/plus"
import BoardManage from "../images/boardManage"
import NewBoard from "../images/newBoard"
import FormManage from "../images/formManage"
import Doc from "../images/doc"
import TaskTick from "../images/taskTick"
import AddField from "../images/addField"
import Translate from "../images/translate"
import DataCollection from "../images/dataCollection"
import DashboardReference from "../images/dashboardReference"
import Configuration from "../images/configuration"
import Chip from "../images/chip"
import SaveForm from "../images/saveForm"
import AnalysisData from "../images/analysisData"
import BoardForums from "../images/boardForums"
import ThreeOptions from "../images/threeOptions"
import Support from "../images/support"
import ProductDevelopment from "../images/productDevelopment"
import Approve from "../images/approve"
import WorkAssignment from "../images/workAssignment"
import EmailAutomation from "../images/emailAutomation"
import SystemInformation from "../images/systemInformation"
import LikeAutomation from "../images/likeAutomation"
import ConditionSetting from "../images/conditionSetting"
import TaskAssignment from "../images/taskAssignment"
import Scenario from "../images/scenario"
import CheckCertificate from "../images/checkCertificate"
import ApprovalProcess from "../images/approvalProcess"
import MailOpen from "../images/mailOpen"
import EmailRecipient from "../images/emailRecipient"
import FormFieldMultiline from "../images/formFieldMultiline"
import FormElements from "../images/formElements"
import LayersReferance from "../images/layersReferance"
import IssueDraft from "../images/issueDraft"
import WorkflowDiagram from "../images/workflowDiagram"
import Robot from "../images/robot"
import Organization from "../images/organization"
import Approved from "../images/approved"
import EmailGenerator from "../images/emailGenerator"

interface Step {
  title: string
  description: string
}

export interface HowToUse {
  title: string
  titleDescription?: string
  description: string
  attachment?: any
  icon?: any
  steps?: Step[]
}

export interface Tips {
  text: string
}

interface SpecificIssueType {
  title: string
  description: string
}

export interface Document {
  title: string
  link: string
  specificIssueType?: SpecificIssueType[]
  typeTitle?: string
  description: string[]
  howToUse: HowToUse[]
  initialIndex: number
  icon?: any
  tips: Tips[]
}

export const iconMap = {
  Plus: Plus,
  Automation: Automation,
  BoardManage: BoardManage,
  NewBoard: NewBoard,
  FormManage: FormManage,
  Doc: Doc,
  TaskTick: TaskTick,
  AddField: AddField,
  Translate: Translate,
  DataCollection: DataCollection,
  DashboardReference: DashboardReference,
  Configuration: Configuration,
  Chip: Chip,
  SaveForm: SaveForm,
  AnalysisData: AnalysisData,
  BoardForums: BoardForums,
  ThreeOptions: ThreeOptions,
  Support: Support,
  ProductDevelopment: ProductDevelopment,
  Approve: Approve,
  WorkAssignment: WorkAssignment,
  EmailAutomation: EmailAutomation,
  SystemInformation: SystemInformation,
  LikeAutomation: LikeAutomation,
  ConditionSetting: ConditionSetting,
  TaskAssignment: TaskAssignment,
  Scenario: Scenario,
  CheckCertificate: CheckCertificate,
  ApprovalProcess: ApprovalProcess,
  MailOpen: MailOpen,
  EmailRecipient: EmailRecipient
}

export const progressIconMap = {
  FormFieldMultiline: FormFieldMultiline,
  FormElements: FormElements,
  LayersReferance: LayersReferance,
  IssueDraft: IssueDraft,
  WorkflowDiagram: WorkflowDiagram,
  Robot: Robot,
  Organization: Organization,
  Approved: Approved,
  EmailGenerator: EmailGenerator
}

export const documents: Document[] = [
  {
    initialIndex: 0,
    title: "firstDocumentTitle",
    link: "/stoneity-forms",
    icon: "FormFieldMultiline",
    description: [
      "firstDocumentDescriptionOne",
    ],
    howToUse: [
      {
        title: "workManagementHowToUseFormTitleOne",
        description: "workManagementHowToUseFormDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleTwo",
        description: "workManagementHowToUseFormDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleThree",
        description: "workManagementHowToUseFormDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleFour",
        description: "workManagementHowToUseFormDescriptionFour",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleFive",
        description: "workManagementHowToUseFormDescriptionFive",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleSix",
        description: "workManagementHowToUseFormDescriptionSix",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormTitleSeven",
        description: "workManagementHowToUseFormDescriptionSeven",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsFormTextOne"
      },
      {
        text: "workManagementTipsFormTextTwo"
      },
      {
        text: "workManagementTipsFormTextThree"
      },
      {
        text: "workManagementTipsFormTextFour"
      },
    ]
  },
  {
    initialIndex: 1,
    title: "secondDocumentTitle",
    link: "/form-fields",
    icon: "FormElements",
    description: [
      "secondDocumentDescriptionOne",
      "secondDocumentDescriptionTwo"
    ],
    howToUse: [
      {
        title: "workManagementHowToUseFormFieldsTitleOne",
        description: "workManagementHowToUseFormFieldsDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleTwo",
        description: "workManagementHowToUseFormFieldsDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleThree",
        description: "workManagementHowToUseFormFieldsDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleFour",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleFive",
        description: "workManagementHowToUseFormFieldsDescriptionFive",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleSix",
        description: "workManagementHowToUseFormFieldsDescriptionSix",
        attachment: ""
      },
      {
        title: "workManagementHowToUseFormFieldsTitleSeven",
        description: "workManagementHowToUseFormFieldsDescriptionSeven",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsFormFieldsTextOne"
      },
      {
        text: "workManagementTipsFormFieldsTextTwo"
      },
      {
        text: "workManagementTipsFormFieldsTextThree"
      },
      {
        text: "workManagementTipsFormFieldsTextFour"
      },
    ]
  },
  {
    initialIndex: 2,
    title: "thirdDocumentTitle",
    link: "/reference-form-field",
    icon: "LayersReferance",
    description: [
      "thirdDocumentDescriptionOne",
      "thirdDocumentDescriptionTwo",
    ],
    howToUse: [
      {
        title: "workManagementHowToUseReferenceFieldsTitleOne",
        description: "workManagementHowToUseReferenceFieldsDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseReferenceFieldsTitleTwo",
        description: "workManagementHowToUseReferenceFieldsDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseReferenceFieldsTitleThree",
        description: "workManagementHowToUseReferenceFieldsDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseReferenceFieldsTitleFour",
        description: "workManagementHowToUseReferenceFieldsDescriptionFour",
        attachment: ""
      },
      {
        title: "workManagementHowToUseReferenceFieldsTitleFive",
        description: "workManagementHowToUseReferenceFieldsDescriptionFive",
        attachment: ""
      },
      {
        title: "workManagementHowToUseReferenceFieldsTitleSix",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsReferenceFieldsTextOne"
      },
      {
        text: "workManagementTipsReferenceFieldsTextTwo"
      },
      {
        text: "workManagementTipsReferenceFieldsTextThree"
      },
    ]
  },
  {
    initialIndex: 3,
    title: "fourthDocumentTitle",
    link: "/issue-type",
    icon: "IssueDraft",
    description: [
      "fourthDocumentDescriptionOne",
      "fourthDocumentDescriptionTwo",
    ],
    specificIssueType: [
      {
        title: "Epic",
        description: "fourthDocumentDescriptionEpic",
      },
      {
        title: "Bug",
        description: "fourthDocumentDescriptionBug",
      },
      {
        title: "Story",
        description: "fourthDocumentDescriptionStory",
      },
      {
        title: "Task",
        description: "fourthDocumentDescriptionTask",
      },
      {
        title: "Subtask",
        description: "fourthDocumentDescriptionSubTask",
      },
    ],
    howToUse: [
      {
        title: "workManagementHowToUseIssueTypeTitleOne",
        description: "workManagementHowToUseIssueTypeDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseIssueTypeTitleTwo",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseIssueTypeTitleThree",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseIssueTypeTitleFour",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseIssueTypeTitleFive",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsIssueTypeTextOne"
      },
      {
        text: "workManagementTipsIssueTypeTextTwo"
      },
    ]
  },
  {
    initialIndex: 4,
    title: "fifthDocumentTitle",
    link: "/workflow",
    icon: "WorkflowDiagram",
    description: [
      "fifthDocumentDescriptionOne",
      "fifthDocumentDescriptionTwo",
    ],
    howToUse: [
      {
        title: "workManagementHowToUseWorkflowTitleOne",
        description: "workManagementHowToUseWorkflowDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseWorkflowTitleTwo",
        description: "workManagementHowToUseWorkflowDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseWorkflowTitleThree",
        description: "workManagementHowToUseWorkflowDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseWorkflowTitleFour",
        description: "workManagementHowToUseWorkflowDescriptionFour",
        attachment: ""
      },
      {
        title: "workManagementHowToUseWorkflowTitleFive",
        description: "workManagementHowToUseWorkflowDescriptionFive",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsWorkflowTextOne"
      },
      {
        text: "workManagementTipsWorkflowTextTwo"
      },
      {
        text: "workManagementTipsWorkflowTextThree"
      },
    ]
  },
  {
    initialIndex: 5,
    title: "sixthDocumentTitle",
    link: "/automation",
    icon: "Robot",
    description: [
      "sixthDocumentDescriptionOne",
      "sixthDocumentAutomationTypeOneDescription",
    ],
    typeTitle: "sixthDocumentAutomationTypeTitle",
    howToUse: [
      {
        title: "workManagementHowToUseAutomationTitleOne",
        description: "workManagementHowToUseAutomationDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAutomationTitleTwo",
        description: "workManagementHowToUseAutomationDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAutomationTitleThree",
        description: "workManagementHowToUseAutomationDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAutomationTitleFour",
        description: "workManagementHowToUseAutomationDescriptionFour",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAutomationTitleFive",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsAutomationTextOne"
      },
      {
        text: "workManagementTipsAutomationTextTwo"
      },
      {
        text: "workManagementTipsAutomationTextThree"
      },
    ]
  },
  {
    initialIndex: 6,
    title: "seventhDocumentTitle",
    link: "/job-assignment-automation",
    icon: "Organization",
    description: [
      "seventhDocumentDescriptionOne"
    ],
    howToUse: [
      {
        title: "workManagementHowToUseAssignmentTitleOne",
        description: "workManagementHowToUseAssignmentDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAssignmentTitleTwo",
        description: "workManagementHowToUseAssignmentDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAssignmentTitleThree",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAssignmentTitleFour",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseAssignmentTitleFive",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsAssignmentTextOne"
      },
      {
        text: "workManagementTipsAssignmentTextTwo"
      },
    ]
  },
  {
    initialIndex: 7,
    title: "eighthDocumentTitle",
    link: "/approval-automation",
    icon: "Approved",
    description: [
      "eighthDocumentDescriptionOne"
    ],
    howToUse: [
      {
        title: "workManagementHowToUseApprovalTitleOne",
        description: "workManagementHowToUseApprovalDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseApprovalTitleTwo",
        description: "workManagementHowToUseApprovalDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseApprovalTitleThree",
        description: "workManagementHowToUseApprovalDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseApprovalTitleFour",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseApprovalTitleFive",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsApprovalTextOne"
      },
      {
        text: "workManagementTipsApprovalTextTwo"
      },
      {
        text: "workManagementTipsApprovalTextThree"
      },
    ]
  },
  {
    initialIndex: 8,
    title: "ninthDocumentTitle",
    link: "/e-mail-sending-automation",
    icon: "EmailGenerator",
    description: [
      "ninthDocumentDescriptionOne"
    ],
    howToUse: [
      {
        title: "workManagementHowToUseMailTitleOne",
        description: "workManagementHowToUseMailDescriptionOne",
        attachment: ""
      },
      {
        title: "workManagementHowToUseMailTitleTwo",
        description: "workManagementHowToUseMailDescriptionTwo",
        attachment: ""
      },
      {
        title: "workManagementHowToUseMailTitleThree",
        description: "workManagementHowToUseMailDescriptionThree",
        attachment: ""
      },
      {
        title: "workManagementHowToUseMailTitleFour",
        description: "",
        attachment: ""
      },
      {
        title: "workManagementHowToUseMailTitleFive",
        description: "",
        attachment: ""
      },
    ],
    tips: [
      {
        text: "workManagementTipsMailTextOne"
      },
      {
        text: "workManagementTipsMailTextTwo"
      },
      {
        text: "workManagementTipsMailTextThree"
      },
    ]
  },
]